import { css } from '@linaria/atomic';

const iconSvgStyle1 = css`
  color: var(--icon-color, currentColor);
`;

export const IconComponentStyles = {
  iconSvgStyle1,
};
